<template>

  <div :class="className" :style="info.css" @click.prevent="click" v-if="img">

    <div class="img" :style="img_style">

    </div>

    <!--<img :src="image2" class="img"/>-->

    <div v-if="loading" class="loading">
      <div class="fall"></div>
      <van-loading type="spinner" color="white"/>
    </div>
  </div>

  <div class="actImgHolder" :style="info.css" v-else-if="!img && edit">

  </div>
</template>


<script>
  /**
   * 如果没有default 并且没有指定的platform ,就不显示图片
   */
  import click_handler from '../../tools/mgtv/click'
  import handler_action from '../../tools/mgtv/action'
  import Vue from 'vue';
  import throttle from '../../tools/throttle'
  import {getJSONP} from "../../api/myaxios";
  import {onUseInfoLoad} from '../../tools/onUseInfoLoad'
  import {inner_check} from '../../tools/mgtv/innerCheck'


  /**
   *
   * 图片组件
   *
   * 换图的说明：
   *   有三种条件，自定义条件（api_current） > 内置事件 (inner_current) > 时间事件（time_current）
   其中内置事件是computed属性
   自定义条件是一次性条件，只有组件加载时会调用
   时间条件会有个Interval来触发

   点击事件也会随着换图而变化
   *
   */

  export default {
    name: 'ActImg',
    props: ['info'],
    components: {},
    data() {
      return {
        api_current: 1, // 自定义条件的结果
        time_current: 1, // 时间条件的结果
        loading: false,
      }
    },
    methods: {
      click() {
        if (!this.img) {
          return;
        }

        if (this.loading) {
          return;
        }
        this.loading = true;
        setTimeout(() => {
          this.loading = false
        }, 333);

        let action = {}
        let event_name = '';
        console.log('current', this.current)
        if (this.current === 1) {
          event_name = `${this.info.name}-默认点击事件`
          action = {
            action_type: this.info.action_type,
            action_info: this.info.action_info,
          }
        } else {
          event_name = `${this.info.name}-换图点击事件`
          action = {
            action_type: this.info.action_type_img2,
            action_info: this.info.action_info_img2,
          }
        }

        click_handler(event_name, () => {
          handler_action(action)
        }, {
          need_login: action.action_info.need_login,
          need_act: action.action_info.need_act,
          need_new_user: action.action_info.need_new_user,
          need_vip_level: action.action_info.need_vip_level,
        })
      },
      calc_condition() {  //计算条件 自定条件和时间条件要初始化
        if (this.info.act_img2_if_api) {
          //接口条件。
          this.loadCheckApi(this.info.act_img2_if_api);
          return
        } else if (this.info.act_img2_if_inner && this.info.act_img2_if_inner !== 'none') {
          //do nothing
          return;
        } else if (this.info.act_img2_if_time && this.info.act_img2_if_time.length === 2) { //空 [], 有设置 ['','']
          const start_time = new Date(this.info.act_img2_if_time[0].replace(/-/g, '/'));
          const end_time = new Date(this.info.act_img2_if_time[1].replace(/-/g, '/'));

          window.clearInterval(this.time_interval);
          this.time_interval = setInterval(() => {
            const now = new Date();
            console.log('interval',now >= start_time && now <= end_time)
            if (now >= start_time && now <= end_time) {
              this.time_current = 2;
            } else if (now > end_time) { //超过结束时间
              this.time_current = 1;
              window.clearInterval(this.time_interval);
            }
          }, 1000);


          return;
        }
      },
      loadCheckApi(api) {
        const must_login = api.indexOf('${TICKET}') !== -1;
        onUseInfoLoad(() => {
          const ticket = window.$bus.user.ticket || '';
          let real_api = api.replace('${TICKET}', ticket).replace('${ACT_NAME}', window.rootdata.act_name);
          if (real_api.indexOf('?') === -1) {
            real_api += ('?t=' + new Date().getTime())
          } else {
            real_api += ('&t=' + new Date().getTime())
          }
          getJSONP(real_api).then(res => {
            if (!res) {
              return;
            }
            if (res.ret === 0) {
              if (res.data.invalid === 1) {
                this.current = 2;
              }
            }
          })
        }, must_login);
      },


    },
    computed: {
      img() {
        //图片地址
        if (this.current === 1) {
          return this.info.act_img_src;
        } else {
          return this.info.act_img2_src;
        }
      },
      img_style() {
        return {
          background: `url(${this.img}) 0% 0% / 100% 100% no-repeat`
        }
      },
      edit() {
        return window.gact.edit
      },
      className() {
        try {
          const name = this.info['animate_name'];
          const times = this.info['animate_times'];
          const delay = this.info['animate_delay'];
          const speed = this.info['animate_speed'];
          const animateClass = `animated ${name} ${times} ${delay} ${speed}`;
          return `actImg ${animateClass}`
        } catch (e) {
          return 'actImg';
        }
      },
      inner_current() { //内置条件的结果
        if (inner_check(this.info.act_img2_if_inner)) {
          return 2
        }
        return 1
      },
      current() {
        if (this.info.act_img2_if_api) { //自定义事件
          return this.api_current;
        } else if (this.info.act_img2_if_inner && this.info.act_img2_if_inner !== 'none') { //
          return this.inner_current
        } else if (this.info.act_img2_if_time && this.info.act_img2_if_time.length === 2) { //时间条件 //空 [], 有设置 ['','']
          return this.time_current;
        }
        return 1
      }
    },
    mounted() {
      this.calc_condition();
    },
    destroyed() {
      clearInterval(this.time_interval);
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .actImg
    overflow hidden
    .img
      display block
      width 100%
      height 100%

  .actImgHolder
    border 1px dashed red
    color red
    display flex
    justify-content center
    align-items center

  .loading
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    display flex
    justify-content center
    align-items center

  .fall
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    background-color: rgba(0, 0, 0, .3);

</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/ActImg.vue